var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/placeholder/components/placeholder-avatar.tsx";
import * as React from 'react';
import { Stack } from 'soapbox/components/ui';

/** Fake avatar to display while data is loading. */
const PlaceholderAvatar = _ref => {
  let {
    size,
    withText = false
  } = _ref;
  const style = React.useMemo(() => {
    if (!size) {
      return {};
    }

    return {
      width: "".concat(size, "px"),
      height: "".concat(size, "px")
    };
  }, [size]);
  return /*#__PURE__*/React.createElement(Stack, {
    space: 3,
    className: "animate-pulse text-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "block mx-auto rounded-full bg-primary-50 dark:bg-primary-800",
    style: style,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }), withText && /*#__PURE__*/React.createElement("div", {
    style: {
      width: size,
      height: 20
    },
    className: "rounded-full bg-primary-50 dark:bg-primary-800",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }));
};

export default PlaceholderAvatar;